/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect } from "react";
import { ThemeContext } from "../../pages/qcast-logo";
import { IoAdd, IoArrowBack, IoPlay, IoStop } from "react-icons/io5";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import getBlobDuration from "get-blob-duration";
import ReactPlayer from "react-player";
import { useMemo } from "react";
import QcastApi from "../../api/api-qcast";
import { CircularProgressbar } from "react-circular-progressbar";

const Review = (props) => {
  const theme = useContext(ThemeContext);
  const { bg, font } = theme;
  const {
    thumbnail,
    intro: introVideo,
    outro: outroVideo,
    recordedVideo: videos,
    recordedVideoData: videoData,
    title,
    tag,
  } = useSelector((state) => state.record);
  const { userId, username, token } = useSelector((state) => state.auth);
  //
  const [currentVideo, setCurrentVideo] = useState(videoData[0]);
  const [currentVidDurr, setCurrentVidDurr] = useState();
  const [currentVidProg, setCurrentVidProg] = useState(0);
  const [tagNo, setAddTag] = useState(1);
  const [isSaving, setIsSaving] = useState(false);

  const [focusNextInput, setFocusNextInput] = useState(false);
  const [play, setPlay] = useState(false);

  const rdDispatch = useDispatch();

  const { saveQcast } = QcastApi();

  useEffect(() => {
    const newVideos = videos.map((item, index) => {
      return {
        file: item,
        id: index + 1,
        transcript: "",
        duration: getBlobDuration(item),
      };
    });

    if (videoData.length < videos.length) {
      rdDispatch({ type: "record/saveVideoData", payload: newVideos });
    }

    Object.keys(tag).forEach((key, idx) => {
      if (tag[key] !== "") {
        setAddTag(idx + 2);
      }
    });
  }, []);

  useEffect(() => {
    if (videoData.length !== 0) {
      setCurrentVideo(videoData[0]);
    }
  }, [videoData]);

  useEffect(() => {
    if (currentVideo?.duration) {
      currentVideo.duration.then((res) => {
        console.log(res);
        setCurrentVidDurr(res);
      });
    }
  }, [currentVideo]);

  const newTag = (idx) => {
    return (
      <input
        className="text-xs h-[2rem] text-center rounded-md bg-[#FFFFFF80] shadow-sm w-full"
        placeholder="Add tag"
        key={idx}
        disabled={idx + 1 < tagNo}
        value={tag[idx]}
        autoFocus={focusNextInput && idx + 1 === tagNo}
        onChange={(e) =>
          rdDispatch({
            type: "record/setTag",
            payload: { type: "add", pos: idx, value: e.target.value },
          })
        }
        onKeyUp={(e) => {
          if (e.key === "Enter" || e.keyCode === 13 || e.code === "Enter") {
            if (tagNo <= 5 && tag[idx].length > 0) {
              setFocusNextInput(true);
            }
            setAddTag((prev) => prev + 1);
          }
        }}
      />
    );
  };

  const handleSave = (e) => {
    e.preventDefault();
    setIsSaving(true);

    const tags = tag.filter((item) => item !== "");

    const qcastDetails = {
      listOfVideo: videoData,
      preview_video_id: introVideo,
      title,
      tag: tags.join("|"),
      Status: "publish",
      userId,
      outrVideo: outroVideo,
      profileName: username,
      cover_photo: thumbnail,
    };

    if (
      videoData &&
      introVideo &&
      title &&
      tags.length > 0 &&
      outroVideo &&
      thumbnail
    ) {
      saveQcast(qcastDetails, token, (data) => {
        if (data.id === 200) {
          rdDispatch({ type: "record/reset" });
          props.proceed();
        } else {
          alert(data.msg);
          setIsSaving(false);
        }
      });
    } else {
      alert("Please fill all the field!");
      setIsSaving(false);
    }
  };

  const allVideos = useMemo(() => {
    return videoData?.map((item, index) => (
      <span key={index} className="relative">
        <p className="absolute lg:flex text-xs top-0 -left-2 text-[#515A6B]">
          {index + 1}.
        </p>
        <label
          htmlFor={index}
          className="w-[2.5rem] rounded-full aspect-square hover:cursor-pointer"
        >
          <input
            id={index}
            type="radio"
            name="editVideo"
            onChange={() => setCurrentVideo(item)}
          />
          <ReactPlayer
            url={window.URL.createObjectURL(item.file)}
            className="option rounded-full overflow-hidden border-2 border-white"
            width={54}
            height={54}
          />
        </label>
      </span>
    ));
  }, [videoData]);

  const displayIntroVid = useMemo(() => {
    if (introVideo) {
      return (
        <ReactPlayer
          url={window.URL.createObjectURL(introVideo)}
          className="option rounded-full overflow-hidden border-2 border-white"
          width={58}
          height={58}
        />
      );
    } else {
      return (
        <div className="w-[3.1rem] lg:w-[3.6rem] aspect-square rounded-full flex flex-col bg-[#FFFFFFB2] shadow-sm">
          <IoAdd
            color={bg}
            className="text-3xl lg:text-4xl text-[#97AAC3] m-auto"
          />
        </div>
      );
    }
  }, [introVideo]);

  const displayOutroVid = useMemo(() => {
    if (outroVideo) {
      return (
        <ReactPlayer
          url={window.URL.createObjectURL(outroVideo)}
          className="option rounded-full overflow-hidden border-2 border-white"
          width={58}
          height={58}
        />
      );
    } else {
      return (
        <div className="w-[3.1rem] lg:w-[3.6rem] aspect-square rounded-full flex flex-col bg-[#FFFFFFB2] shadow-sm">
          <IoAdd
            color={bg}
            className="text-3xl lg:text-4xl text-[#97AAC3] m-auto"
          />
        </div>
      );
    }
  }, [outroVideo]);

  const currenVidBlob = useMemo(() => {
    if (currentVideo) {
      return window.URL.createObjectURL(currentVideo.file);
    }
  }, [currentVideo]);

  return (
    <div
      id="review"
      className="w-[19rem] md:w-[24rem] lg:w-[29rem] rounded-[20px] flex flex-col bg-[#FFFFFF80] backdrop-blur-[50px] overflow-hidden"
    >
      <nav className="bg-[#FFFFFF80] w-full grid grid-cols-3 px-2 py-2">
        <button
          className="justify-self-start mr-2 w-[1.2rem] h-[1.5rem] lg:w-[1.5rem] aspect-square rounded-full bg-[#8DACCD54] flex flex-col "
          onClick={props.back}
          disabled={isSaving}
        >
          <IoArrowBack
            color="#2C3037"
            className="m-auto w-full text-xs lg:text-sm"
          />
        </button>
        <p className="justify-self-center font-medium w-fit text-[#1E3053] whitespace-nowrap">
          Review Qcast
        </p>
        <span></span>
      </nav>
      {/* BODY */}
      <div className="w-full px-2 md:px-4 flex flex-col space-y-3 items-center pt-4 pb-4">
        <span className="w-full flex flex-row space-x-3">
          <span className="h-fit relative w-[8rem] rounded-full flex flex-col aspect-square overflow-hidden">
            {currentVideo ? (
              <>
                <CircularProgressbar
                  value={currentVidProg}
                  maxValue={currentVidDurr}
                  strokeWidth={4}
                  styles={{
                    trail: {
                      stroke: `#FFF`,
                    },
                  }}
                />
                <ReactPlayer
                  url={currenVidBlob}
                  className="rounded-full overflow-hidden m-auto"
                  width={86}
                  height={86}
                  playing={play}
                  onProgress={(state) => {
                    setCurrentVidProg(state.playedSeconds);
                  }}
                  onEnded={() => {
                    setCurrentVidProg(currentVidDurr);
                    setPlay(false);
                  }}
                />
                <button
                  onClick={() => setPlay(!play)}
                  className="absolute bg-gradient-to-tr from-[#F1F9FF] to-[#DCE8F6] rounded-full p-[2px] bottom-2 right-[40%]"
                >
                  {play ? (
                    <IoStop className="text-xs text-gray-400" />
                  ) : (
                    <IoPlay className="text-xs text-gray-400" />
                  )}
                </button>
              </>
            ) : null}
          </span>
          <div className="w-full grid grid-cols-2 text-sm space-y-2">
            <div className=" col-span-2 w-full h-full flex flex-row space-x-2 lg:space-x-4">
              {allVideos}
            </div>
            <button
              onClick={props.edit}
              style={{ color: bg }}
              disabled={isSaving}
              className="bg-[#FFFFFFB2] py-2 rounded-lg text-[#7B94B5] flex flex-row items-center justify-center space-x-1 shadow-sm"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 21 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.4974 3.33774L16.5858 7.42608L6.23697 17.7749L2.15091 13.6866L12.4974 3.33774ZM19.6881 2.35173L17.8648 0.52847C17.1602 -0.176157 16.016 -0.176157 15.309 0.52847L13.5625 2.27497L17.6509 6.36335L19.6881 4.32615C20.2346 3.7796 20.2346 2.89824 19.6881 2.35173ZM0.011377 19.433C-0.0630262 19.7679 0.239299 20.0679 0.574189 19.9865L5.13 18.8819L1.04394 14.7936L0.011377 19.433Z"
                  fill={bg}
                />
              </svg>
              <p className="text-xs">Edit Qcast</p>
            </button>
            <button
              onClick={props.transcript}
              style={{ color: bg }}
              disabled
              className="bg-[#FFFFFFB2] rounded-lg text-[#7B94B5] flex flex-row items-center justify-center space-x-1 shadow-sm tooltip"
            >
              <svg
                width="15"
                height="15"
                viewBox="0 0 16 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.4701 0V3.90313H10.1709V20H5.29915V3.90313H0V0H15.4701Z"
                  fill={bg}
                />
              </svg>
              <p className="text-xs">Transcript</p>
              <span className="tooltiptext">Coming soon...</span>
            </button>
          </div>
        </span>
        <input
          onChange={(e) =>
            rdDispatch({ type: "record/setTitle", payload: e.target.value })
          }
          value={title}
          disabled={isSaving}
          className="text-xs px-2 bg-[#FFFFFF80] w-full h-[2rem] rounded-lg shadow-sm"
          placeholder="Enter Qcast title"
        />
        <span className="flex flex-row items-center w-full">
          {Array(tagNo)
            .fill(newTag)
            .map((item, index) => {
              if (index <= 5 && index + 1 === tagNo) {
                return (
                  <span className="w-1/4 mr-1" key={index}>
                    {item(index)}
                  </span>
                );
              } else if (index <= 5) {
                return (
                  <span
                    onClick={(e) => {
                      console.log(e);
                      rdDispatch({
                        type: "record/setTag",
                        payload: { type: "del", pos: index },
                      });
                      setAddTag((prev) => prev - 1);
                    }}
                    key={index}
                    className="text-xs h-[2rem] flex justify-center items-center rounded-md bg-[#FFFFFF80] shadow-sm w-1/4 mr-1"
                  >
                    {tag[index]}
                  </span>
                );
              }
              return <></>;
            })}
          {tagNo <= 5 && (
            <button onClick={() => setAddTag((prev) => prev + 1)}>
              <IoAdd color={bg} className="text-xl text-[#2E689D]" />
            </button>
          )}
        </span>
        <span className="w-full justify-between grid grid-cols-3">
          <div className="flex flex-col items-center">
            <button onClick={props.thumbnail} disabled={isSaving}>
              {thumbnail ? (
                <img
                  src={thumbnail}
                  className="w-[3.1rem] lg:w-[3.6rem] border-2 border-[#FFFFFF80] rounded-full m-auto object-cover"
                  alt="Thumbnail"
                />
              ) : (
                <div className="w-[3.1rem] lg:w-[3.6rem] aspect-square rounded-full flex flex-col bg-[#FFFFFFB2] shadow-sm">
                  <IoAdd
                    color={bg}
                    className="text-3xl lg:text-4xl text-[#97AAC3] m-auto"
                  />
                </div>
              )}
            </button>
            <p className="text-xs text-[#2C3037] mt-1">
              {thumbnail ? "Edit Thumbnail" : "Add Thumbnail"}
            </p>
          </div>
          <div className="flex flex-col items-center">
            <button onClick={props.addIntro} disabled={isSaving}>
              {displayIntroVid}
            </button>

            <p className="text-xs text-[#2C3037] mt-1">
              {introVideo ? "Edit Intro" : "Add Intro"}
            </p>
          </div>
          <div className="flex flex-col items-center">
            <button onClick={props.addOutro} disabled={isSaving}>
              {displayOutroVid}
            </button>
            <p className="text-xs text-[#2C3037] mt-1">
              {outroVideo ? "Edit Outro" : "Add Outro"}
            </p>
          </div>
        </span>
        <span className="flex flex-row space-x-1 w-[50%]">
          <button
            style={{ backgroundColor: bg, color: font }}
            onClick={handleSave}
            disabled={isSaving}
            className="flex-grow rounded-full p-1 text-xs py-2 shadow-md relative"
          >
            {isSaving ? (
              <>
                {" "}
                Saving...{" "}
                <svg
                  className="h-3 w-3 absolute right-[12px] top-1/2 transform -translate-y-1/2"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 100 100"
                  preserveAspectRatio="xMidYMid"
                >
                  <circle
                    cx="50"
                    cy="50"
                    fill="none"
                    stroke="#ffffff"
                    strokeWidth="8"
                    r="45"
                    strokeDasharray="212.05750411731105 72.68583470577035"
                  >
                    <animateTransform
                      attributeName="transform"
                      type="rotate"
                      repeatCount="indefinite"
                      dur="1s"
                      values="0 50 50;360 50 50"
                      keyTimes="0;1"
                    ></animateTransform>
                  </circle>
                </svg>{" "}
              </>
            ) : (
              "Save"
            )}
          </button>
        </span>
      </div>
    </div>
  );
};

export default Review;
